import { connect } from 'react-redux';
import Layout from './Layout';
import { checkForSession, getUser } from '../../actions/fender-connect';

const mapState = state => {
  const { fenderConnect } = state;
  const { hasSubscription } = fenderConnect || {};
  return {
    hasSubscription,
  };
};

const mapDispatch = {
  checkForSession,
  getUser,
};

export default connect(
  mapState,
  mapDispatch,
)(Layout);
